import { Injectable } from '@angular/core';
import { ObservableService } from '@damofire/data-angular-commons';
import { SearchResult } from '@damofire/data-commons';
import { LayoutTextSegment } from '../warehouse/warehouse.dto';
import { cloneDeep } from 'lodash-es';

export function generateAndAssignTextIds(texts: LayoutTextSegment[]): LayoutTextSegment[] {
  const timestamp: number = Date.now();

  return texts.map((layoutText, index) =>
    layoutText._id
      ? layoutText
      : {
          ...cloneDeep(layoutText),
          _id: `${timestamp + index}`,
        },
  );
}

@Injectable()
export abstract class WarehouseLayoutTextService extends ObservableService<LayoutTextSegment> {
  protected constructor() {
    super();
  }

  abstract search(divisionId: string): Promise<SearchResult<LayoutTextSegment>>;
  abstract create(divisionId: string, segments: LayoutTextSegment[]): Promise<void>;
  abstract delete(divisionId: string, segments: LayoutTextSegment[]): Promise<void>;
  abstract update(divisionId: string, segments: LayoutTextSegment[]): Promise<void>;
}
